import React, { Component } from 'react';
import { connect } from 'react-redux';

import Box from 'grommet/components/Box';
import Tabs from 'grommet/components/Tabs';
import Tab from 'grommet/components/Tab';
import Heading from 'grommet/components/Heading';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Form from 'grommet/components/Form';
import FormField from 'grommet/components/FormField';
import Layer from 'grommet/components/Layer';
import Table from 'grommet/components/Table';
import TableHeader from 'grommet/components/TableHeader';
import TableRow from 'grommet/components/TableRow';
import List from 'grommet/components/List';
import ListItem from 'grommet/components/ListItem';
import Paragraph from 'grommet/components/Paragraph';
import Spinning from 'grommet/components/icons/Spinning'
import FormClose from 'grommet/components/icons/base/FormClose';
import queryString from 'query-string'
import { compareGlgrowthData, exportCompareSolutionData } from '../../State/actions/sessions';

class GlGrowth extends Component{
    constructor(props) {
        super(props);        
        this.state = {
            newHeaderOne: "",
            newHeaderTwo: "",
            phaseData: '',
            comparedData: '',            
            configurations1Option: this.props.comparedata=== undefined? '': this.props.comparedata['Solutions']['Configurations']['Configuration'],            
            configurations2Option: [],
            CompareField_Label : 'Select Configuration'           
        };
        this.onConfigurationChange = this.onConfigurationChange.bind(this);       
    }

    componentDidMount(){              
        let queryParameter = queryString.parse(window.location.search);
        let strSessionID = queryParameter.sizerReference;
        this.props.compareGlgrowth(strSessionID);            
    }   
    
    onConfigurationChange = (e) => {
        if(e.target.name === "configurationOne") {
            this.state.newHeaderOne = e.option;
        }
        else if(e.target.name === "configurationTwo") {
            this.state.newHeaderTwo = e.option;
        }  

        if(this.state.newHeaderOne === this.state.newHeaderTwo){            
            const currentIndex = this.state.configurations1Option.indexOf(this.state.newHeaderOne);
            const nextIndex = (currentIndex + 1) % this.state.configurations1Option.length;
            this.state.newHeaderOne = this.state.configurations1Option[nextIndex];
        }
        this.setState({});
    }

    redirectUrl() {
        window.location.replace(this.props.externalAppProps.ssetUrl.replace('!&%2F', '/').replace('%3F', '?'));
    }    

    onExport() {
        let hideDetailsColumn = this.props.comparedata.Solutions.Items.Item[0]["@Header"] === '-' ? true : false;
        let tableHeading = hideDetailsColumn ? [this.state.newHeaderOne, this.state.newHeaderTwo, "Delta"] : ["Details", this.state.newHeaderOne, this.state.newHeaderTwo, "Delta"];

        let text = {
            "Data": {
                "input": {
                    "content": [
                        {
                            "Items": [
                                {
                                    "Item": tableHeading
                                }
                            ]
                        }
                    ]
                }
            }
        }
        let items = this.props.comparedata["Solutions"]["Items"]["Item"].map((item, index) => {
            if (this.state.newHeaderOne === '') {
                this.state.configurations1Option = this.props.comparedata['Solutions']['Configurations']['Configuration'];
                this.state.newHeaderOne = this.props.comparedata["Solutions"]["Configurations"]["Configuration"][0];
            }
            if (this.state.newHeaderTwo === '') {
                this.state.newHeaderTwo = this.props.comparedata["Solutions"]["Configurations"]["Configuration"][1];
            }
            let headerOneValue = this.state.newHeaderOne;
            let headerTwoValue = this.state.newHeaderTwo;

            if (this.state.configurations1Option.length > 1) {
                this.state.configurations2Option = this.state.configurations1Option.concat([]);
                this.state.configurations2Option.splice(this.state.configurations2Option.indexOf(headerOneValue), 1);
                headerTwoValue = this.state.configurations2Option.indexOf(headerTwoValue) !== -1 ? headerTwoValue : this.state.configurations2Option[0];
            } else {
                this.state.configurations2Option = this.state.configurations1Option[1];
            }

            let len = item["Configuration"].length;
            let columnOneValue = '';
            let columnTwovalue = '';
            let count1 = '';
            let count2 = '';
            let diff = '';
            let fontWeight = '';
            for (let i = 0; i < len; i++) {
                if (headerOneValue === item["Configuration"][i]["@Name"]) {
                    columnOneValue = item["Configuration"][i]["#text"];
                    count1 = item["Configuration"][i]["@Count"];

                }
                if (headerTwoValue === item["Configuration"][i]["@Name"]) {
                    columnTwovalue = item["Configuration"][i]["#text"];
                    count2 = item["Configuration"][i]["@Count"];
                }
                if (count1 !== '-') {
                    if (count1 && count2) {
                        diff = Math.abs(count1 - count2) + item["Configuration"][i]["@Description"];
                        if (hideDetailsColumn) {
                            diff = (count1 - count2) === 0 ? 'None' : diff;
                        }
                    }
                } else {
                    diff = item["Configuration"][i]["@Description"];
                }
                if (item["Configuration"][i]["@Count"] === "-") {
                    fontWeight = "bold";
                } else {
                    fontWeight = '';
                }
            }
            let tableRow = hideDetailsColumn ? [columnOneValue, columnTwovalue, diff] : [item['@Header'], columnOneValue, columnTwovalue, diff];
            let arr = {
                'fontWeight' : fontWeight,
                "Item": tableRow
            };
            text.Data.input.content[0]["Items"].push(arr)
        });
        //let jsontext=JSON.stringify(text)
        //dumm.push(text)
        this.props.onExportCompaeSolution(text)

    }

    render() {
        if(this.props.comparedata === undefined){
            return '';
        }
        let ConfigurationData = '';
        let TableData = '';
        let tbltdStyle = { padding: '5px', textAlign: 'left', width: '100px', border: "1px solid rgb(204, 204, 204)" };

        let hideDetailsColumn = this.props.comparedata.Solutions.Items.Item[0]["@Header"] === '-' ? true : false;

        this.state.phaseData = this.props.comparedata["Solutions"]["Items"]["Item"].map((item, index) => {
            if (this.state.newHeaderOne === '') {
                this.state.configurations1Option = this.props.comparedata['Solutions']['Configurations']['Configuration'];
                this.state.newHeaderOne = this.props.comparedata["Solutions"]["Configurations"]["Configuration"][0];
            }
            if(this.state.newHeaderTwo === '') {
                this.state.newHeaderTwo = this.props.comparedata["Solutions"]["Configurations"]["Configuration"][1];
            }
            let headerOneValue = this.state.newHeaderOne;
            let headerTwoValue = this.state.newHeaderTwo;
            
            if(this.props.comparedata["Solutions"]["@Header"]!==undefined)
                   this.state.CompareField_Label = this.props.comparedata["Solutions"]["@Header"];
                   
            if(this.state.configurations1Option.length>1){
                this.state.configurations2Option= this.state.configurations1Option.concat([]);
                this.state.configurations2Option.splice(this.state.configurations2Option.indexOf(headerOneValue), 1);
                headerTwoValue = this.state.configurations2Option.indexOf(headerTwoValue) !== -1 ?headerTwoValue : this.state.configurations2Option[0];
            } else {
                this.state.configurations2Option= this.state.configurations1Option[1];
            }              
           
            let len = item["Configuration"].length;
            let columnOneValue= '';
            let columnTwovalue= '';
            let count1 = '';
            let count2 = '';
            let diff = '';
            for(let i=0; i<len; i++) {
                if(headerOneValue === item["Configuration"][i]["@Name"]){
                    columnOneValue = item["Configuration"][i]["#text"];                    
                    count1 = item["Configuration"][i]["@Count"];
                    
                }
                if(headerTwoValue === item["Configuration"][i]["@Name"]){
                    columnTwovalue = item["Configuration"][i]["#text"];
                    count2 = item["Configuration"][i]["@Count"];
                }
                if (count1 !== '-') {
                    if (count1 && count2) {
                        diff = Math.abs(count1 - count2) + item["Configuration"][i]["@Description"];
                        if (hideDetailsColumn) {
                            diff = (count1 - count2) === 0 ? 'None' : diff;
                        }
                    }
                } else {
                    diff = item["Configuration"][i]["@Description"];
                }
                if (!Number.isInteger(Math.abs(diff)) && !Number.isNaN(Math.abs(diff)))
                    diff = Math.abs(diff).toFixed(2);

                if (item["Configuration"][i]["@Count"] === "-") {
                    tbltdStyle = { padding: '5px', textAlign: 'left', width: '100px', border: "1px solid rgb(204, 204, 204)", fontWeight: 'bold' };
                } else {
                    tbltdStyle = { padding: '5px', textAlign: 'left', width: '100px', border: "1px solid rgb(204, 204, 204)" };
                }

            }

            return <TableRow key={index} scrollable={true}>
                {hideDetailsColumn ? '' : <td style={tbltdStyle} >{item['@Header']}</td>}
                <td style={tbltdStyle} >{columnOneValue}</td>
                <td style={tbltdStyle} >{columnTwovalue}</td>
                <td style={tbltdStyle} >{diff}</td>
            </TableRow>
        })

        ConfigurationData = <Box direction='row' margin='none' pad={{ between: 'medium' }} separator="all" style={{ padding: '10px', width:'80%', border:"white" }}>
        <Box id='Select configuration' margin='none' pad="none" separator="none" >            
            <Box margin="none" pad={{ between: 'small' }} separator="none" style={{ padding: '10px', width: '300px' }} >
                <Form >
                    <FormField className="" label={this.state.CompareField_Label} style={{maxWidth: "225px"}}>
                        <Select name="configurationOne" onChange={(e)=>{this.onConfigurationChange(e)}}
                            options={this.state.configurations1Option}
                            value={this.state.newHeaderOne}
                            />
                    </FormField>
                </Form>
            </Box>
        </Box>
        <Box id='Select configuration' margin='none' pad="none" separator="none" >            
            <Box direction='row' margin="none" pad={{ between: 'medium' }} separator="none" style={{ padding: '10px', width: '300px' }}>                
                <Form >
                    <FormField className="" label={this.state.CompareField_Label} style={{maxWidth: "225px"}}>
                        <Select name= "configurationTwo" onChange={(e)=>{this.onConfigurationChange(e)}}
                            options={this.state.configurations2Option}
                            value={this.state.newHeaderTwo}
                            />
                        </FormField>
                    </Form>
                </Box>
            </Box>

            <Box direction='row' margin="none" pad={{ between: 'medium' }} separator="none">
                <Button label='Export to Excel' primary={true} onClick={this.onExport.bind(this)} style={{ height: '40px', marginTop: '20px', width: '200px' }} />
            </Box>
        </Box>

        let labels = '';
        if (hideDetailsColumn) {
            labels = [this.state.newHeaderOne, this.state.newHeaderTwo, 'Delta'];
        } else {
            labels = ['Details', this.state.newHeaderOne, this.state.newHeaderTwo, 'Delta'];
        }

        TableData =
            <Box direction='row' separator='bottom' className="" justify='center' align='left'
                style={{ height: '450px', overflowY: 'auto', overflowX: 'hidden', width: '80% !important' }}>
                {/* <Button label='Export to Excel' primary={true} onClick={this.onExport} style={{height:'45px',padding: '7px', position: 'relative', left: '650px', bottom: '76px'}} /> */}
                <br />
                <Table>
                    <TableHeader labels={labels} style={{ visibility: 'visible', borderBottom: '1px solid white', backgroundColor: "#425563", color: "white", fontSize: "120" }} />
                    <tbody scrollable={true}>
                        {this.state.phaseData}
                    </tbody>
                </Table>
            </Box>

        return(
            <Box margin="none" pad="small" style={{width:'100% !important',height:'100%'}}>                    
                 <Box direction='row' margin="none" pad={{between: 'small'}} style={{ height: '55px'}}>
                      <Heading tag='h2' margin='small' strong={true} style={{fontSize: '2em'}}>Compare Solutions : </Heading>
                      
                      <Button label='Close' primary={true} onClick={()=>{this.redirectUrl()}} style={{height:'40px', marginTop: '10px', position: 'relative', left:'825px'}} />
                 </Box>
                 <br/>
                                 
                 {ConfigurationData}
                 {TableData}
            </Box>
         );
    }
}
const mapStateToProps = (state) => {
    let comparedata = undefined;  
    if(state.sessions.activeSession!== undefined && state.sessions.activeSession !== '') {
        comparedata= state.sessions.activeSession;
    } 
    return {        
        comparedata: comparedata
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        compareGlgrowth: (data) => {
            dispatch(compareGlgrowthData(data));
        },
        onExportCompaeSolution: (text) => {
            dispatch(exportCompareSolutionData(text));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GlGrowth);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/GlGrowth.js